import {
  actionTypes,
  loggedUserFailure,
  loggedUserSuccess,
  setLanguageRequestFailure,
  setLanguageRequestSuccess,
} from "./actions";
import { fetchLoggedUserInfo, fetchSetLanguage } from "./services";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

export const fetchLoggedUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.LOGGED_USER_REQUEST),
    mergeMap(() =>
      fetchLoggedUserInfo().pipe(
        // da capire cosa fare del primo elemento della lista
        map((response: any) => loggedUserSuccess(response[0])),
        catchError((error: any) => of(loggedUserFailure(error)))
      )
    )
  );

export const setSelectedLanguageEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SET_LANGUAGE_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchSetLanguage(action.payload).pipe(
        map((response: any) => setLanguageRequestSuccess(response)),
        catchError((error: any) => of(setLanguageRequestFailure(error)))
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [fetchLoggedUserEpic, setSelectedLanguageEpic];
